'use client';

import React, { useEffect, useMemo, useRef } from 'react';
import { useSnackbar } from '@/hooks/useSnackbar';
import * as S from './styles';
import { IconeCheck } from '@/components/atoms/Icones/IconeCheck';
import { theme } from '@/styles/theme';
import { SnackbarColor } from '@/contexts/SnackbarContext';
import Button from '@/components/atoms/Button';

export const corTextoSnackbar = ({
  color,
  highContrast,
}: {
  color: SnackbarColor;
  highContrast?: boolean;
}) => {
  if (color === 'success') {
    return theme.colors.neutral.neutral[1];
  }

  if (color === 'neutral') {
    if (highContrast) return theme.colors.neutral.neutral[1];
    return theme.tokens.colors.white_contrast;
  }
};

export default function Snackbar() {
  const { snackbarProps, esconderSnackbar } = useSnackbar();
  const {
    color,
    mensagem,
    visivel,
    size,
    highContrast,
    variant,
    callbackFunction,
    textoBotao,
  } = snackbarProps;

  // eslint-disable-next-line no-undef
  const snackbarTimer = useRef<NodeJS.Timeout | null>(null);

  function iniciarTimer() {
    if (snackbarTimer?.current) return;
    snackbarTimer.current = setInterval(() => {
      pararTimer();
    }, 3000);
  }

  function pararTimer() {
    if (snackbarTimer?.current) {
      esconderSnackbar();
      clearInterval(snackbarTimer.current);
      snackbarTimer.current = null;
    }
  }

  useEffect(() => {
    if (visivel) {
      iniciarTimer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visivel]);

  const iconeSnackbar = useMemo(() => {
    const propsIcone = {
      color: corTextoSnackbar({ color, highContrast }),
      size: theme.typography.font.size[size < 2 ? 2 : size],
    };
    if (color === 'success') return <IconeCheck {...propsIcone} />;
  }, [size, color, highContrast]);

  function executarFuncaoCallback() {
    if (!callbackFunction) return;
    pararTimer();

    setTimeout(() => {
      callbackFunction();
    }, 700);
  }

  return (
    <S.Container
      $variant={variant}
      $highContrast={highContrast}
      $size={size}
      $color={color}
      $snackbarVisivel={visivel}
      onClick={pararTimer}
    >
      {iconeSnackbar}
      {mensagem}
      {callbackFunction && textoBotao ? (
        <Button
          $size={1}
          $variant="solid"
          $color="neutral"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $text={textoBotao}
          $onClick={executarFuncaoCallback}
        />
      ) : null}
    </S.Container>
  );
}
